import React, { createContext, useContext, useState, useEffect } from "react"
import { authApi } from "../lib/api"

const AuthContext = createContext(null)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for current user from meta tag (set by Rails)
    const userMeta = document.querySelector('meta[name="current-user"]')
    if (userMeta) {
      try {
        const userData = JSON.parse(userMeta.getAttribute("content"))
        setUser(userData)
      } catch (e) {
        console.error("Failed to parse user data:", e)
      }
    }
    setLoading(false)
  }, [])

  const signIn = async (email, password) => {
    const data = await authApi.signIn(email, password)
    setUser(data.user)
    return data.user
  }

  const signUp = async (email, password, passwordConfirmation, options = {}) => {
    const data = await authApi.signUp(email, password, passwordConfirmation, options)
    setUser(data.user)
    return data.user
  }

  const signOut = async () => {
    await authApi.signOut()
    setUser(null)
    window.location.href = "/users/sign_in"
  }

  const updateUser = (updates) => {
    setUser((prev) => ({ ...prev, ...updates }))
  }

  const value = {
    user,
    setUser,
    loading,
    isAuthenticated: !!user,
    isStudent: user?.role === "student",
    isParent: user?.role === "parent",
    signIn,
    signUp,
    signOut,
    updateUser,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
